// extracted by mini-css-extract-plugin
export default {"title":"title__I4umU","header":"header__OVZyn","active":"active__r+Z6z","infoButton":"infoButton__5SDr8"};